import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
export function disableConsoleInDev() {
    const env = process.env.REACT_APP_ENV;
    console.log("Console_debug_status : ", env); // Check this appears once
    if (env === 'production') {
      console.log = function () {};
      console.warn = function () {};
      console.error = function () {};
      console.info = function () {};
    }
  }
  disableConsoleInDev();
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
